<template>
    <v-card
            :class="cardClass"
            :max-width="maxWidth"
            color="grey darken-2"
            @mouseover="cardClass=clickable ? 'mt-5 card elevation-11 cursor-pointer' : 'mt-5 card elevation-11'"
            @mouseout="cardClass='mt-5 card'"
            @click="cardClicked"
    >
        <v-card
                class="v-sheet--offset mx-auto"
                :color="color"
                elevation="12"
                max-width="calc(100% - 25%)"
        >

            <v-card-text class="subtitle-1 text-center pa-2 font-weight-medium">
                {{title.toUpperCase()}}
            </v-card-text>

        </v-card>

        <v-card-text class="pt-0">
            <slot></slot>
        </v-card-text>

        <footer-note v-if="footerNote">{{footerNote}}</footer-note>

    </v-card>
</template>

<script>

    import FooterNote from "./FooterNote";

    export default {

        components: {
            FooterNote
        },

        props: {
            prefix: {
                type: String,
                required: false,
                default: null,
            },
            title: {
                type: String,
                required: true,
            },
            height: {
                type: Number,
                required: false,
                default: 100
            },
            color: {
                type: String,
                required: false,
                default: 'primary'
            },
            loading: {
                type: Boolean,
                required: false,
                default: false,
            },
            clickable: {
                type: Boolean,
                required: false,
                default: false,
            },
            footerNote: {
                type: String,
                required: false,
                default: null,
            },
            maxWidth: {
                type: Number,
                required: false,
                default: 600
            }
        },

        data() {
            return {
                cardClass: 'mt-5 card',
                boxValue: 0,
                autoPostfixValue: null,
            }
        },

        watch: {

        },

        methods: {

            cardClicked() {
                if (this.clickable) {
                    this.$emit('click');
                }
            },

        },

        mounted() {
        }
    }
</script>

<style scoped>

    .card {
        margin: auto;
    }

    .v-sheet--offset {
        top: -24px;
        position: relative;
    }
</style>
